import React, { useCallback, useState } from 'react'
import { Label, ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { Input } from '@/components/inputs'
import { EnumDropDownList } from '@/components/enumDropDownList'
import { reportCellCommentStatus } from '@/enums/reportCellCommentStatus'
import { useLocalization } from '@/hooks/localization'

function CellCommentDialog (props) {
  const { localize } = useLocalization()
  const [value, setValue] = useState(props.value || '')
  const onValueChange = useCallback(e => setValue(e.target.value), [])
  const [status, setStatus] = useState(props.status || 0)
  const onStatusChange = useCallback(e => setStatus(e.value), [])
  const { onAction } = props
  const handleAction = useCallback(() => onAction({ value, status }), [onAction, value, status])
  return (
    <React.Fragment>
      <BasicHeader {...props} />
      <ModalBody>
        <Row>
          <Label>
            {localize('Reporting.Comment')}
          </Label>
          <Input
            autoFocus
            defaultValue={value}
            onChange={onValueChange} />
        </Row>
        <Row>
          <Label>
            {localize('Reporting.CommentStatus')}
          </Label>
          <EnumDropDownList enumDefinition={reportCellCommentStatus} value={status} onChange={onStatusChange} />
        </Row>
      </ModalBody>
      <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={handleAction} />
    </React.Fragment>
  )
}

export default {
  component: CellCommentDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/cellComment.js